const ComparisonTypeConfig = {
  collection: "comparison_template_type",
  fields: ["id", "key"],

  filter: "filter[status][_eq]=active",

  adapter: class ComparisonTemplateType {
    constructor(type) {
      this.id = type.id;
      this.key = type.key;
    }
  }
};

export default ComparisonTypeConfig;
